import { Component, computed, input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrightsideUiModule } from '@brightside/brightside-ui';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
    selector: 'bw-carousel-wrapper-legacy',
    imports: [CommonModule, BrightsideUiModule],
    templateUrl: './carousel-wrapper.component.html',
    styleUrl: './carousel-wrapper.component.scss',
    animations: [
        trigger('slide', [
            transition(':enter', [
                style({ transform: '{{enterTransform}}', opacity: 0 }),
                animate('400ms ease-out', style({ transform: 'translateX(0)', opacity: 1 }))
            ], { params: { enterTransform: 'translateX(100%)' } }),
            transition(':leave', [
                animate('400ms ease-out', style({ transform: '{{leaveTransform}}', opacity: 0 }))
            ], { params: { leaveTransform: 'translateX(-100%)' } })
        ])
    ]
})
export class CarouselWrapperComponentLegacy {
  readonly totalItems = input<number>(0);

  readonly dotsIndices = computed(() =>
    Array.from({ length: this.totalItems() }, (_, i) => i)
  );

  readonly currentIndex = signal(0);
  animationState: any = { value: '', params: { enterTransform: 'translateX(100%)', leaveTransform: 'translateX(-100%)' } };

  next() {
    this.animationState = 'left';
    this.currentIndex.set(
      (this.currentIndex() + 1) % this.totalItems()
    );
  }

  prev() {
    this.animationState = 'right';
    this.currentIndex.set(
      (this.currentIndex() - 1 + this.totalItems()) % this.totalItems()
    );
  }

  goTo(index: number) {
    if (index > this.currentIndex()) {
      this.animationState = 'left';
    } else if (index < this.currentIndex()) {
      this.animationState = 'right';
    }
    this.currentIndex.set(index);
  }
}
